import Clipboard from "v-clipboard";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 引入Element UI组件
import "./plugins/element";

import VueLazyload from "vue-lazyload";
import XepUI from "xep-ui";
import "./assets/css/common.scss";
import "./assets/css/reset.css";
import "./utils/iconfont";
// import "./utils/aliplayer.min";
import gloabl from "./assets/js/common/global";
import placeholder from "./assets/js/directive/placeholder";
import schollToLoad from "./assets/js/directive/scrollToLoad";
import htmlToPdf from "./utils/htmlToPdf";
const loadimage = require("@/assets/images/londing.gif");
Vue.prototype.$store = store;

Vue.use(XepUI);
Vue.use(VueLazyload, {
  preLoad: 2,
  loading: loadimage,
  attempt: 1,
});
Vue.use(Clipboard);
Vue.directive("placeholder", placeholder);
Vue.directive(schollToLoad.name, schollToLoad);
Vue.use(htmlToPdf);
Vue.config.productionTip = false;

/**
 * 将params更新到路由中
 * @param {*} params 需要追加或者更新的参数
 * @param {*} removeKeys 需要移除的查询参数
 * @param {*} isForceRemove 是否强制删除（当removeKeys和params中的key有冲突的时候，强制删除）。默认不强制删除，也就是params中的参数一定会加上
 */
Vue.prototype.$updatePathQuery = function (
  params,
  removeKeys,
  isForceRemove = false
) {
  let query = this.$route.query;
  query = JSON.parse(JSON.stringify(query));
  //添加key
  if (params && Object.keys(params).length) {
    query = Object.assign(query, params);
  }
  //删除不用的key
  if (removeKeys && removeKeys.length) {
    for (let key of removeKeys) {
      if (!(key in params) || isForceRemove) {
        delete query[key];
      }
    }
  }
  this.$router.push({ query: { ...query } });
};
Vue.prototype.$global = gloabl;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
